import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EvergreenComponent } from "./documents/evergreen/evergreen.component";
import { PendingComponent } from "./documents/pending/pending.component";
import { PreviewComponent } from "./documents/preview/preview.component";

const routes: Routes = [
  { path: "document/b/:key", component: PendingComponent },
  { path: "document/e/:key", component: EvergreenComponent },
  {
    path: "document/p/:key",
    component: EvergreenComponent,
    data: { isPreview: true },
  },
  { path: "document/preview", component: PreviewComponent },
  { path: "**", component: PendingComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
